import { Injectable } from "@angular/core";

@Injectable()
export class HomeService {
  constructor() {}

  setHomeList() {
    return new Promise((resolve, reject) => {
      try {
        let userDetails = JSON.parse(localStorage.getItem("user_details"));

        if (
          userDetails["email"] &&
          userDetails["list_name"] &&
          userDetails["season"] &&
          userDetails["user_id"]
        ) {
          localStorage.setItem("list_name", userDetails.list_name);
          localStorage.setItem("season", userDetails.season);
          localStorage.setItem("user_id", userDetails.user_id);
          return resolve();
        } else {
          return reject(new Error("Not logged in..."));
        }
      } catch (e) {
        return reject(new Error("Not logged in..."));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts